import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export const useLookups = () => {
  const [lk, setLk] = useState(null);
  useEffect(() => { api.get("/lookups").then((r) => setLk(r.data)); }, []);
  return lk;
};

export function MeasurePicker({ value, onChange, testId = "measure-picker" }) {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  useEffect(() => {
    const t = setTimeout(() => api.get("/measures", { params: { q: q || undefined, page_size: 15 } }).then((r) => setItems(r.data.items)), 250);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div className="space-y-1.5">
      <input className="otms-input" placeholder="Search measure…" value={q} onChange={(e) => setQ(e.target.value)} data-testid={`${testId}-search`} />
      <select className="otms-input" value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testId}>
        <option value="">— Select measure —</option>
        {items.map((m) => <option key={m.id} value={m.id}>{m.official_number || m.tracking_ref} — {m.proposed_title.slice(0, 80)}</option>)}
      </select>
    </div>
  );
}

const MANILA_MS = 8 * 3600 * 1000;

export const toLocalInput = (iso) => (iso ? new Date(new Date(iso).getTime() + MANILA_MS).toISOString().slice(0, 16) : "");

export const fromLocalInput = (v) => (v ? new Date(`${v}:00+08:00`).toISOString() : null);
